import {
  ClientDto,
  MessageTemplateAdminDto,
} from '@act/shared/data-transfer-objects';
import { ColumnConfiguration } from '@act/storybook';

export const TemplateTableColumns = (
  clientList: ClientDto[],
  categoryName: string
): ColumnConfiguration<MessageTemplateAdminDto>[] => [
  {
    id: 'template',
    value: (props: MessageTemplateAdminDto) => {
      const maxLength = 50;
      return props.template.length > maxLength
        ? `${props.template.substring(0, maxLength)}...`
        : props.template;
    },
    isNumeric: false,
    shouldDisablePadding: false,
    sortable: true,
    title: 'Template Preview',
  },
  {
    id: 'categoryId',
    value: () => {
      return categoryName;
    },
    isNumeric: false,
    shouldDisablePadding: false,
    title: 'Category',
  },
  {
    id: 'sortOrder',
    value: 'sortOrder',
    isNumeric: true,
    shouldDisablePadding: false,
    title: 'Sort Order',
  },
  {
    id: 'template_clients',
    value: (props: MessageTemplateAdminDto) => {
      const clientNames = props.template_clients
        .map(
          template_client =>
            clientList.find(client => client.id === template_client)?.name
        )
        .filter(Boolean);

      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          {clientNames.map((name, index) => (
            <div key={index}>{name}</div>
          ))}
        </div>
      );
    },
    isNumeric: false,
    shouldDisablePadding: false,
    title: 'Clients',
  },
  {
    id: 'allClients',
    value: (props: MessageTemplateAdminDto) => {
      return props.allClients === true ? 'Yes' : 'No';
    },
    isNumeric: false,
    shouldDisablePadding: false,
    title: 'All Clients',
  },
];
